/**
 * Site Content for NIZUS Application
 * Contains static data for Landing Page, Navigation, etc.
 */

export const siteContent = {
    // Hero/Welcome Carousel
    heroSlides: [
        {
            id: 1,
            titleFr: "Découvrez le mode question-réponse",
            titleEn: "Discover the question-answer mode",
            descriptionFr: "Entraînez-vous différemment grâce à notre nouvel outil de correction immédiate.",
            descriptionEn: "Practice differently with our new instant correction tool.",
            imageFr: "/img/imgFlash.png",
            imageEn: "/img/imgFlash.png",
        },
        {
            id: 2,
            titleFr: "Vous préférez écouter que lire ?",
            titleEn: "Do you prefer listening to reading?",
            descriptionFr: "Le cours PPL est désormais disponible dans sa version audio.",
            descriptionEn: "The PPL course is now available in audio version.",
            imageFr: "/img/imgAudio.png",
            imageEn: "/img/imgAudio.png",
        },
        {
            id: 3,
            titleFr: "nizus, c'est aussi du cours au sol !",
            titleEn: "nizus is also ground school!",
            descriptionFr: "Suivez le cours au sol PPL à votre rythme et obtenez votre lettre de recommandation.",
            descriptionEn: "Follow the PPL ground school at your own pace and get your recommendation letter.",
            imageFr: "/img/Nouveau cours.png",
            imageEn: "/img/New course.png",
        },
        {
            id: 4,
            titleFr: "Examens IFR",
            titleEn: "IFR Exams",
            descriptionFr: "Entraînez-vous toujours mieux grâce à nos nouvelles navigations !",
            descriptionEn: "Train even better with our new navigation features!",
            imageFr: "/img/Examens IFR.png",
            imageEn: "/img/IFR Exams.png",
        },
        {
            id: 5,
            titleFr: "Par des pilotes, pour des pilotes",
            titleEn: "By pilots, for pilots",
            descriptionFr: "Avec nizus, entraînez-vous aux examens aéronautiques écrits de Transports Canada.",
            descriptionEn: "With nizus, train for Transport Canada written aeronautical exams.",
            imageFr: "/img/Cours en ligne et préparation aux examens de Transports Canada.png",
            imageEn: "/img/Online courses and Transport Canada exams preparation.png",
        },
        {
            id: 6,
            titleFr: "Suivez-nous !",
            titleEn: "Follow us!",
            descriptionFr: "Pour connaître les dernières mises à jour, les nouveautés et les concours, suivez-nous sur facebook.",
            descriptionEn: "Follow us on Facebook for the latest updates, new features and contests.",
            imageFr: "/img/Suivez-nous.png",
            imageEn: "/img/Follow-us.png",
        },
    ],

    // Advantages Section
    advantages: [
        {
            id: 1,
            titleFr: "Les statistiques",
            titleEn: "Statistics",
            descriptionFr: "Ayez une vue d'ensemble et détaillée sur votre progression, ciblez vos points forts et repérez vos points faibles.",
            descriptionEn: "Get an overview and detailed view of your progress, target your strengths and identify your weaknesses.",
            image: "/img/welcome/avantage-statistiques.png",
        },
        {
            id: 2,
            titleFr: "Les explications",
            titleEn: "Explanations",
            descriptionFr: "Lors des corrections, chaque réponse est accompagnée de son explication.",
            descriptionEn: "During corrections, each answer is accompanied by an explanation.",
            image: "/img/welcome/avantage-explications.png",
        },
        {
            id: 3,
            titleFr: "Recommandation",
            titleEn: "Recommendation",
            descriptionFr: "Obtenez une lettre de recommandation pour votre examen après avoir complété le programme.",
            descriptionEn: "Get a recommendation letter for your exam after completing the program.",
            image: "/img/welcome/avantage-lettre de recommandation.png",
        },
        {
            id: 4,
            titleFr: "La centralisation",
            titleEn: "Centralization",
            descriptionFr: "Travaillez où vous voulez, quand vous voulez et sur n'importe quelle plateforme, vous n'avez besoin que d'une connexion internet.",
            descriptionEn: "Work where you want, when you want and on any platform, all you need is an internet connection.",
            image: "/img/welcome/avantage-centralisation.png",
        },
    ],

    // Courses & Exams Section
    courseExam: {
        titleFr: "Des cours & des examens",
        titleEn: "Courses & Exams",
        descriptionFr: "Nos cours et examens, conformes aux exigences de Transports Canada, sont mis à jour régulièrement afin de toujours mieux vous former et vous préparer à vos examens.",
        descriptionEn: "Our courses and exams, in compliance with Transport Canada requirements, are regularly updated to better train and prepare you for your exams.",
        image: "/img/welcome/Des cours et des examens.png",
        ctaFr: "Découvrir nos abonnements",
        ctaEn: "Discover our subscriptions",
        ctaLink: "/levels",
    },

    // Subjects Section
    subjects: [
        {
            id: 1,
            nameFr: "Droit aérien",
            nameEn: "Air Law",
            descriptionFr: "En ce moment même, plus de 10 000 aéronefs parcourent le ciel. Il est donc essentiel que chacun connaisse et applique la loi. Nous vous donnons les clés pour aborder cette matière l'esprit tranquille.",
            descriptionEn: "At this very second, more than 10,000 aircraft are flying in the sky. It is therefore essential for everyone to know the law and to follow it. We give you the keys to approach this subject with a mind at ease.",
            image: "/img/subjects/sujet-droit aérien.png",
        },
        {
            id: 2,
            nameFr: "Météorologie",
            nameEn: "Meteorology",
            descriptionFr: "Un(e) bon(ne) pilote doit connaître la météo sur le bout des doigts avant d'entreprendre un vol. Nous nous efforçons de vous fournir une base de données complète et intuitive pour que le ciel se découvre sur votre passage.",
            descriptionEn: "Good pilots must know meteorology inside and out before starting a flight. We strive to provide you with a complete and intuitive database so that the sky holds no mysteries.",
            image: "/img/subjects/sujet-météorologie.png",
        },
        {
            id: 3,
            nameFr: "Navigation",
            nameEn: "Navigation",
            descriptionFr: "Elle représente 95 % du travail du ou de la pilote en vol et doit être parfaitement assimilée. Une bonne compréhension de cette matière est indispensable pour un vol sécuritaire et plaisant.",
            descriptionEn: "Navigation represents 95% of a pilot's work and must feel like second nature; total comprehension of this subject is indispensable for a safe and pleasant flight.",
            image: "/img/subjects/sujet-navigation.png",
        },
        {
            id: 4,
            nameFr: "Connaissances générales",
            nameEn: "General Knowledge",
            descriptionFr: "Toutes les questions auxquelles un(e) pilote sera confronté(e) à un moment ou à un autre de sa carrière y sont regroupées. Une bonne connaissance du sujet aujourd'hui fera de vous un(e) meilleur(e) pilote demain.",
            descriptionEn: "We've gathered together all the questions that a pilot will have to answer at some point in their career. A good foundation today will make you a better pilot tomorrow.",
            image: "/img/subjects/sujet-connaissances générales.png",
        },
    ],

    // Pricing Plans
    pricingPlans: [
        {
            id: 1,
            nameFr: "Gratuit",
            nameEn: "Free",
            price: 0,
            currency: "CAD",
            badgeFr: "Gratuit",
            badgeEn: "Free",
            colorClass: "free",
            featuresFr: [
                "Accès à 10 questions",
                "Pas de simulateur",
                "Pas de certificat",
                "Support communautaire",
            ],
            featuresEn: [
                "Access to 10 questions",
                "No simulator",
                "No certificate",
                "Community support",
            ],
            ctaFr: "S'inscrire",
            ctaEn: "Sign Up",
            ctaLink: "/auth/register",
        },
        {
            id: 2,
            nameFr: "Basique",
            nameEn: "Basic",
            price: 9.99,
            currency: "CAD",
            badgeFr: "POPULAIRE",
            badgeEn: "POPULAR",
            colorClass: "basic",
            popular: true,
            featuresFr: [
                "Questions illimitées",
                "Simulateur complet",
                "Certificat officiel",
                "Support courriel",
                "Accès 30 jours",
            ],
            featuresEn: [
                "Unlimited questions",
                "Full simulator",
                "Official certificate",
                "Email support",
                "30-day access",
            ],
            ctaFr: "Commencer",
            ctaEn: "Start",
            ctaLink: "/checkout/basic",
        },
        {
            id: 3,
            nameFr: "Premium",
            nameEn: "Premium",
            price: 19.99,
            currency: "CAD",
            badgeFr: "Premium",
            badgeEn: "Premium",
            colorClass: "premium",
            featuresFr: [
                "Tout du plan Basique",
                "Coaching personnel",
                "Accès VIP",
                "Support prioritaire",
                "Accès 365 jours",
                "Mises à jour gratuites",
            ],
            featuresEn: [
                "Everything in Basic",
                "Personal coaching",
                "VIP access",
                "Priority support",
                "365-day access",
                "Free updates",
            ],
            ctaFr: "Devenir Premium",
            ctaEn: "Go Premium",
            ctaLink: "/checkout/premium",
        },
    ],

    // Navigation Links
    // "Accueil" / "Home" intentionally omitted: the logo in the header pill
    // already navigates to "/", so this link would be redundant.
    navigation: {
        mainFr: [
            { label: "Licences & qualifications", href: "/levels" },
        ],
        mainEn: [
            { label: "Licences & Ratings", href: "/levels" },
        ],
        footerFr: [
            { label: "Blogue", href: "/blog" },
            { label: "À propos", href: "/about" },
            { label: "Contact", href: "/contact" },
            { label: "FAQ", href: "/faq" },
            { label: "Partenariats", href: "/partnership" },
            { label: "Conditions d'utilisation", href: "/cgu" },
            { label: "Confidentialité", href: "/privacy" },
        ],
        footerEn: [
            { label: "Blog", href: "/blog" },
            { label: "About", href: "/about" },
            { label: "Contact", href: "/contact" },
            { label: "FAQ", href: "/faq" },
            { label: "Partnerships", href: "/partnership" },
            { label: "Terms of Use", href: "/cgu" },
            { label: "Privacy", href: "/privacy" },
        ],
    },

    // Landing page V2 — dark modern design
    landingV2: {
        hero: {
            titleFr: "Devenez un\npilote avisé.",
            titleEn: "Become a\nwise pilot.",
            subtitleFr: "nizus est la référence pour la préparation aux examens aéronautiques écrits de Transports Canada. Cours au sol, examens blancs et statistiques détaillées.",
            subtitleEn: "nizus is the reference for Transport Canada written aeronautical exam preparation. Ground school, practice exams and detailed statistics.",
            ctaFr: "Commencer gratuitement",
            ctaEn: "Start for free",
        },
        magic: {
            titleFr: "La magie nizus",
            titleEn: "The nizus magic",
            descriptionFr: "En matière de formation aéronautique, il n'existait pas d'outil complet et intuitif. nizus change la donne avec une plateforme qui centralise cours au sol et examens blancs, le tout conforme aux exigences de Transports Canada.",
            descriptionEn: "There was no complete and intuitive tool for aeronautical training. nizus changes the game with a platform that centralizes ground school and practice exams, all in compliance with Transport Canada requirements.",
        },
        courseExam: {
            titleFr: "Des cours\n& des examens",
            titleEn: "Courses\n& Exams",
            descriptionFr: "Suivez le cours au sol à votre rythme et entraînez-vous avec des examens blancs conformes aux exigences de Transports Canada. Le tout mis à jour régulièrement.",
            descriptionEn: "Follow ground school at your own pace and practice with mock exams that comply with Transport Canada requirements. All regularly updated.",
        },
        subjects: {
            titleFr: "Apprenez\npar matières",
            titleEn: "Learn\nby subjects",
            descriptionFr: "Chaque matière est couverte en profondeur pour vous préparer au mieux à vos examens aéronautiques.",
            descriptionEn: "Each subject is covered in depth to best prepare you for your aeronautical exams.",
        },
        levels: {
            titleFr: "Choisissez\nvotre niveau",
            titleEn: "Choose\nyour level",
            descriptionFr: "Que vous débutiez ou que vous soyez un pilote expérimenté, nizus a le contenu qu'il vous faut.",
            descriptionEn: "Whether you're a beginner or an experienced pilot, nizus has the content you need.",
        },

        // Hero variants for additional pages
        heroProgress: {
            titleFr: "L'endroit pour\nprogresser.",
            titleEn: "The place to\nprogress.",
            subtitleFr: "Cours au sol interactifs, examens blancs et suivi détaillé de votre progression. nizus vous accompagne à chaque étape.",
            subtitleEn: "Interactive ground school, practice exams and detailed progress tracking. nizus supports you at every step.",
            ctaFr: "Commencer gratuitement",
            ctaEn: "Start for free",
        },
        heroImprove: {
            titleFr: "Un endroit pour\ns'améliorer.",
            titleEn: "A place to\nimprove.",
            subtitleFr: "Des cours structurés et des examens réalistes pour vous préparer aux examens de Transports Canada avec confiance.",
            subtitleEn: "Structured courses and realistic exams to prepare you for Transport Canada exams with confidence.",
            ctaFr: "Commencer gratuitement",
            ctaEn: "Start for free",
        },

        // Alternative section titles
        subjectsAlt: {
            titleFr: "Découvrez\nnos matières",
            titleEn: "Discover\nour subjects",
            descriptionFr: "Chaque matière est couverte en profondeur pour vous préparer au mieux à vos examens aéronautiques.",
            descriptionEn: "Each subject is covered in depth to best prepare you for your aeronautical exams.",
        },
        levelsAlt: {
            titleFr: "Des niveaux pour\ntout le monde",
            titleEn: "Levels for\neveryone",
            descriptionFr: "Que vous débutiez ou que vous soyez un pilote expérimenté, nizus a le contenu qu'il vous faut.",
            descriptionEn: "Whether you're a beginner or an experienced pilot, nizus has the content you need.",
        },

        // Referral/discount section
        referral: {
            titleFr: "Économisez grâce\nà vos amis",
            titleEn: "Save thanks\nto your friends",
            descriptionFr: "Invitez vos amis pilotes et obtenez des réductions sur vos abonnements. Plus vous parrainez, plus vous économisez.",
            descriptionEn: "Invite your pilot friends and get discounts on your subscriptions. The more you refer, the more you save.",
            ctaFr: "En savoir plus",
            ctaEn: "Learn more",
            altTitleFr: "Obtenez des\nréductions",
            altTitleEn: "Get\ndiscounts",
        },

        // Device showcase section
        deviceShowcase: {
            titleFr: "Des cours\n& des examens",
            titleEn: "Courses\n& Exams",
            descriptionFr: "Suivez le cours au sol à votre rythme et entraînez-vous avec des examens blancs conformes aux exigences de Transports Canada.",
            descriptionEn: "Follow ground school at your own pace and practice with mock exams that comply with Transport Canada requirements.",
        },
    },
};

export default siteContent;
